import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/cashierApi'
import http from '@core/fetch'
import { message, Modal } from 'hljd'
import mainStore from '@components/Main/store'
import { getJSONObj } from '@hlj/hlj-utils'
import { statistic, isSiDaTeam, isSiDaMember } from '@util'
import { STATISTIC_PROMOTION_ENSURE_RECHARGE } from '@constant'
import commonApi from '@api/common'
import walletApi from '@api/a_mao/merchantWallet'
import { PAY_BALANCE, PAY_ALIPAY, PAY_WECHAT, PAY_CARD } from './constant'

const confirm = Modal.confirm

/**
 * TODO，整个支付都要重写了！
 */
class Store {
  cant //不能使用的支付方式, eg. cant=1,2,3,4
  @observable price //需要支付价格
  @observable orderPrice
  @observable serviceTime //服务期限
  title //订单标题
  apiName // 付款api
  checkApi //微信支付时需要间歇性刷接口来验证是否已支付,可不填
  return_url //支付完成后的回调地址
  product_id //购买单独服务时需要的参数 product_id

  payParams //支付时需要传的参数
  checkParams //检测是否支付的信息
  queryParams = {} //url参数

  apiList = {
    pay: body => {
      const p = {
        ...body
      }
      const { deductible_money } = this.queryParams
      if (deductible_money) {
        p.deductible_money = deductible_money
      }

      return http.post(this.apiName, { body: p })
    },
    checkPay: () => http(this.checkApi)
  }

  @action
  checkTitle = () => {
    return this.title.indexOf('水镜') > -1 ? true : false
  }

  @observable payType = 2 //默认支付方式，若没有传值则默认为2
  @action
  changePayType = e => {
    this.payType = e.target.value
    clearInterval(this.timeout)
  }

  @observable walletShow = false
  @observable loading = true
  @action
  getWithdraw = async () => {
    const { price } = this
    let {
      data: { withdraw_ability }
    } = await Api.withdraw_statistics_v2()
    runInAction(() => {
      if (+withdraw_ability < +price) {
        this.walletShow = true
      } else {
        this.walletShow = false
      }
      this.loading = false
    })
  }

  @observable cardPayVisible = false

  @observable user_name = ''
  @observable user_idcard = ''
  @observable user_bankcard = ''
  @observable user_phone = ''

  @observable
  changeValue = type => e => {
    this[type] = e.target.value
  }

  @action
  toSubmit = () => {
    const { user_name, user_idcard, user_bankcard, user_phone } = this
    if (!user_name) {
      return message.warning('输入本人真实姓名！')
    }
    if (!user_idcard) {
      return message.warning('请输入身份证号！')
    }
    if (!user_bankcard) {
      return message.warning('请输入银行卡号！')
    }
    if (!user_phone) {
      return message.warning('请输入银行手机号！')
    }

    this.cardPay()
  }

  @action
  closeModal = () => {
    clearInterval(this.timeout)
    this.cardPayVisible = false
    this.user_name = ''
    this.user_idcard = ''
    this.user_bankcard = ''
    this.user_phone = ''
  }

  @observable weiXinVisible = false
  @observable weiXinQrCode = ''

  @action
  close = () => {
    this.weiXinVisible = false
    clearInterval(this.timeout)
  }

  @observable cashFlowId = '' // 余额支付订单号

  walletPay = async () => {
    const { return_url, payParams, price, payType, productCoupon } = this

    let _params
    if (payParams) {
      _params = JSON.parse(payParams)
    }

    let params = {
      agent: 'wallet',
      return_url: this.checkTitle()
        ? `${decodeURIComponent(
            window.location.origin + return_url + '#/index'
          )}`
        : window.location.origin + window.location.pathname + '#' + return_url,
      product_id: this.product_id || '', //只有在购买单个服务时传
      coupon_id: productCoupon.id || '',
      ..._params
    }

    statistic(STATISTIC_PROMOTION_ENSURE_RECHARGE, 'click', {
      price,
      payType
    })

    let { success, data, msg } = await this.apiList.pay(params)
    if (success) {
      // 跳转到等待页面
      const { cash_flow_id } = data
      this.cashFlowId = cash_flow_id
      this.flowType = 'loading'
      this.goLoading()
    } else {
      return message.warning(msg)
    }
  }

  @action
  aliPay = async () => {
    const { return_url, payParams, price, payType, productCoupon } = this

    let _params
    if (payParams) {
      _params = JSON.parse(payParams)
    }

    let params = {
      agent: 'alipay',
      return_url: this.checkTitle()
        ? `${decodeURIComponent(
            window.location.origin + return_url + '#/index'
          )}`
        : window.location.origin + window.location.pathname + '#' + return_url,
      product_id: this.product_id || '', //只有在购买单个服务时传
      coupon_id: productCoupon.id || '',
      ..._params
    }

    statistic(STATISTIC_PROMOTION_ENSURE_RECHARGE, 'click', {
      price,
      payType
    })

    let {
      success,
      data: { pay_params }
    } = await this.apiList.pay(params)
    if (success) {
      document.write(pay_params)
    }
  }

  @action
  weixinPay = async () => {
    const {
      return_url,
      payParams,
      checkApi,
      price,
      payType,
      productCoupon
    } = this

    let _params
    if (payParams) {
      _params = JSON.parse(payParams)
    }

    let params = {
      agent: 'wx_native',
      return_url: this.checkTitle()
        ? `${decodeURIComponent(
            window.location.origin + return_url + '#/index'
          )}`
        : window.location.origin + window.location.pathname + '#' + return_url,
      product_id: this.product_id || '', //只有在购买单个服务时传
      coupon_id: productCoupon.id || '',
      ..._params
    }

    statistic(STATISTIC_PROMOTION_ENSURE_RECHARGE, 'click', {
      price,
      payType
    })

    let {
      success,
      data: { pay_params }
    } = await this.apiList.pay(params)
    if (success) {
      this.weiXinQrCode = getJSONObj(pay_params).short_url
      this.weiXinVisible = true
      if (checkApi) {
        this.checkIfWeixinPayed()
      }
    }
  }

  @action
  cardPay = async () => {
    const {
      return_url,
      user_name,
      user_idcard,
      user_bankcard,
      user_phone,
      payParams,
      price,
      payType,
      productCoupon
    } = this

    let _params
    if (payParams) {
      _params = JSON.parse(payParams)
    }

    let params = {
      agent: 'llpay',
      return_url: this.checkTitle()
        ? `${decodeURIComponent(
            window.location.origin + return_url + '#/index'
          )}`
        : window.location.origin + window.location.pathname + '#' + return_url,
      product_id: this.product_id || '', //只有在购买单个服务时传
      coupon_id: productCoupon.id || '',
      user_name,
      user_idcard,
      user_bankcard,
      user_phone,
      ..._params
    }

    statistic(STATISTIC_PROMOTION_ENSURE_RECHARGE, 'click', {
      price,
      payType
    })

    let {
      success,
      data: { pay_params }
    } = await this.apiList.pay(params)
    if (success) {
      document.write(pay_params)
    }
  }

  @action
  toPay = () => {
    const { payType, price } = this
    if (!this.isUltimate()) {
      this.productCoupon = {}
    }
    // this.product_id = this.isUltimate() ? this.product_id : ''

    if (payType == PAY_BALANCE) {
      confirm({
        title: '订单金额为' + price + '元，确认使用余额支付么？',
        onOk: () => {
          this.walletPay()
        }
      })
    }

    if (payType == PAY_ALIPAY) {
      this.aliPay()
    }

    if (payType == PAY_WECHAT) {
      this.weixinPay()
    }

    if (payType == PAY_CARD) {
      this.cardPayVisible = true
    }
  }

  @observable timeout
  @action
  checkIfWeixinPayed = () => {
    const { return_url, checkParams, title } = this
    if (title.indexOf('小程序') > -1) {
      mainStore.getShopInfo()
    }
    let key = JSON.parse(checkParams)
    let checkKey = Object.keys(key)[0]
    let checkVal = Object.values(key)[0]

    this.timeout = setInterval(async () => {
      let { data } = await this.apiList.checkPay()
      if (data[checkKey] == checkVal) {
        this.weiXinVisible = false
        clearInterval(this.timeout)
        if (title.indexOf('小程序') > -1) {
          mainStore.getShopInfo()
        }
        message.success('支付成功！')
        setTimeout(() => {
          window.location.href = this.checkTitle()
            ? return_url + '#/index'
            : '#' + return_url
        }, 2000)
      }
    }, 2000)
  }

  @action
  payAlready = () => {
    const { return_url } = this
    this.weiXinVisible = false
    window.location.href = this.checkTitle()
      ? return_url + '#/index'
      : '#' + return_url
    // window.location.reload()
  }

  isUltimate = () => {
    return (
      this.product_id == 50 || this.product_id == 262 || this.product_id == 263
    )
  }

  @observable productCoupon = {}
  @action
  getProductCoupon = async () => {
    const { product_id, price } = this
    const { success, data } = await commonApi.productCoupon()
    runInAction(() => {
      if (success && this.isUltimate(product_id)) {
        const [productCoupon] = (data || []).filter(
          item => item.product_id == product_id
        )
        this.productCoupon = productCoupon || {}
        const { money_value } = this.productCoupon
        if (money_value > 0) {
          this.price = (price - money_value).toFixed(2)
        }
      }
    })
  }

  @action
  initParams = params => {
    const {
      cant,
      payType,
      price,
      title,
      apiName,
      checkApi,
      product_id,
      return_url,
      payParams,
      checkParams,
      serviceTime
    } = params
    this.cant = cant
    this.queryParams = params
    if (payType) {
      this.payType = +payType
    }
    this.title = title
    this.apiName = apiName
    this.checkApi = checkApi
    this.payParams = payParams
    this.checkParams = checkParams
    this.return_url = return_url
    this.product_id = product_id
    this.serviceTime = serviceTime
    // 区分四大团队和个人
    if (product_id == 50) {
      if (isSiDaTeam()) {
        this.product_id = 263
      }
      if (isSiDaMember()) {
        this.product_id = 262
      }
    }

    if (price) {
      if (price.indexOf('.') > -1) {
        this.price = price
        this.orderPrice = price
      } else {
        this.price = price + '.00'
        this.orderPrice = price + '.00'
      }
    } else {
      this.price = 0
      this.orderPrice = 0
    }
    this.getProductCoupon()
  }

  // 清分余额支付页面新增逻辑
  goBackHome = () => {
    window.location.href = '#/localMerchant/home'
  }
  // 跳转余额支付等待页面
  goLoading = () => {
    window.location.href =
      '#/localMerchant/resultPage?cashFlowId=' +
      this.cashFlowId +
      '&type=' +
      this.flowType
  }
  initFlowId = (id, type) => {
    this.cashFlowId = id
    this.flowType = type
  }
  @observable flowType = 'loading'
  // 确认余额支付银行回调是否成功
  getCashFlowStatus = async () => {
    const { success, data } = await walletApi.getCashFlowStatus({
      cashFlowId: this.cashFlowId
    })
    if (success) {
      const { status } = data
      if (status) {
        // 1为已支付
        this.flowType = 'success'
        this.goLoading()
      } else {
        // 0为未支付
        this.flowType = 'error'
        this.goLoading()
      }
    }
  }
}

export default new Store()
